var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDatabaseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.056,
    height: 21.018,
    viewBox: "0 0 19.056 21.018",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Database_icon",
    d: "M20.083,10.5l1.2.721a.5.5,0,0,1,0,.858L12,17.65,2.715,12.079a.5.5,0,0,1,0-.858l1.2-.721L12,15.35Zm0,4.7,1.2.721a.5.5,0,0,1,0,.858l-8.77,5.262a1,1,0,0,1-1.03,0l-8.77-5.262a.5.5,0,0,1,0-.858l1.2-.721L12,20.05l8.083-4.85ZM12.514,1.309l8.771,5.262a.5.5,0,0,1,0,.858L12,13,2.715,7.429a.5.5,0,0,1,0-.858l8.77-5.262a1,1,0,0,1,1.03,0Z",
    transform: "translate(-2.472 -1.166)",
    fill: "#379eda"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabaseIcon);
export default __webpack_public_path__ + "static/media/Database_icon.282759b7115c49ffbd6d113a6065799e.svg";
export { ForwardRef as ReactComponent };